import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/functions';

// import {firebaseConfig} from '../constants/defaultValues'
import { FIREBASE_CONFIG } from '../config/env'
firebase.initializeApp(FIREBASE_CONFIG);

const auth = firebase.auth;
const firestore = firebase.firestore;
const storage = firebase.storage;
const functions = firebase.functions;
const FieldValue = firebase.firestore.FieldValue;

export {
   auth,
   firestore,
   storage,
   functions,
   FieldValue
};
